import React from "react";

/**
 * Mobile-first responsive "cards → table" renderer without duplicating loops.
 * - Mobile: each item is a card and shows field labels.
 * - sm+: becomes a grid row with an optional header row.
 *
 * NOTE: pass a concrete Tailwind columns class (e.g. "sm:grid-cols-5")
 * so Tailwind can include it (avoid dynamic class names).
 */
export default function ResponsiveFields({
	items = [],
	columns = [],
	columnsClassName = "sm:grid-cols-2",
	getKey,
	showHeader = true,
	variant = "rows",
	className = "",
}) {
	if (!Array.isArray(items) || items.length === 0) return null;
	if (!Array.isArray(columns) || columns.length === 0) return null;

	const isCards = variant === "cards";
	const effectiveShowHeader = isCards ? false : showHeader;

	return (
		<div className={className}>
			{effectiveShowHeader && (
				<div className={`hidden sm:grid ${columnsClassName} gap-2 px-2 pb-2 font-bold`}>
					{columns.map((c) => (
						<div key={c.key} className="min-w-0">
							{c.label}
						</div>
					))}
				</div>
			)}
			<div className={isCards ? "space-y-3" : "space-y-3 sm:space-y-0 sm:divide-y sm:divide-surface/30"}>
				{items.map((item, idx) => {
					const key = getKey ? getKey(item, idx) : idx;
					return (
						<div
							key={key}
							className={
								isCards
									? `p-3 border rounded-lg bg-light grid gap-2 ${columnsClassName}`
									: `p-3 border rounded-lg bg-light sm:bg-transparent sm:border-0 sm:rounded-none sm:grid ${columnsClassName} sm:gap-2 sm:p-2`
							}
						>
							{columns.map((c) => (
								<div key={c.key} className="min-w-0">
									<div className={`text-xs font-semibold text-secondary ${effectiveShowHeader ? "sm:hidden" : ""}`}>{c.label}</div>
									<div className={c.valueClassName || ""}>{typeof c.render === "function" ? c.render(item, idx) : null}</div>
								</div>
							))}
						</div>
					);
				})}
			</div>
		</div>
	);
}

